import React, { SetStateAction } from 'react';
import { useEffect, useMemo, useState } from 'react';
import TableContainer from '../../../components/Table/TableContainer';
import ToggleSwitch from '../../../components/ToggleSwitch';
import edit from '../../../assets/images/svgIcons/edit_iocn.svg';
import InputSearch from '../../../components/InputSearch';
import { useAppDispatch, useAppSelector } from '../../../store/store';
import ManageClassificationModal from '../../../components/Models/ManageSetupsModalComponent/ManageClassificationModal';
import { changestatusClassificationThunk, getClassificationThunk } from '../../../store/asyncThunks/manage/setups';
import ConfirmationModal from '../../../components/Models/ConfirmationModal';
import TableSkeleton from '../../../components/skeleton/TableSkeleton';
import { updateClassificationData } from '../../../store/slices/manage/setups/Classification/getClassification';
import { Card } from 'reactstrap';
import TableWithCardLoader from '../../../components/TableWithCardLoader';

interface ClassificationProps {
  currentPage: number;
  setCurrentPage: SetStateAction<any>;
  reset: number;
}

const Classifications = (props: ClassificationProps) => {
  const { currentPage, setCurrentPage, reset } = props;

  document.title = `Setups | ${process.env.REACT_APP_DOCUMENT_TITLE}`;

  const dispatch = useAppDispatch()

  const [searchValue, setSearchValue] = useState("");
  const [EditData, setEditData] = useState<any>(null);
  const [showModal, setshowModal] = useState(true);
  const [statusData, setStatusData] = useState<any>(null);
  const [statusShowModal, setstatusShowModal] = useState(true);
  const pageSize = process.env.REACT_APP_PAGE_SIZE || 10;
  const getClassificationList = useAppSelector((state) => state?.getClassificationReducer?.data?.classification);
  const getClassificationLoading = useAppSelector((state) => state?.getClassificationReducer?.loading);
  const classificationCount = useAppSelector((state) => state?.getClassificationReducer?.data?.totalCount);
  const ClassificationStatusLoader = useAppSelector((state) => state?.changestatusClassificationReducer?.loading)

  const handleSearch = (value: any) => {
    setSearchValue(value);
    setCurrentPage(1);
  }

  useEffect(() => {
    getData()
  }, [searchValue, currentPage, reset]);

  const getData = async () => {
    const data: any = {}
    data["currentPage"] = currentPage
    data["pageSize"] = pageSize
    data["data"] = { search: searchValue }
    await dispatch(getClassificationThunk(data));
  }

  const toggleModal = () => {
    setshowModal(!showModal);
  };

  const toggleStatusModal = () => {
    setstatusShowModal(!statusShowModal);
  };

  const handleEditClick = (Rowdata: any) => {
    setEditData(Rowdata);
    setshowModal(true);
  };

  const handleToggleSwitch = (Rowdata: any) => {
    setStatusData(Rowdata);
    setstatusShowModal(true);
  }

  const ClassificationUpdateStatus = () => {
    const status = {
      status: statusData?.status === "INACTIVE" ? "ACTIVE" : "INACTIVE",
    }
    const data: any = {
      data: status,
      id: statusData?._id,
      afterSuccess: (newStatus:any) => {
        dispatch(updateClassificationData(newStatus));
        setstatusShowModal(false);
      },
    };
    dispatch(changestatusClassificationThunk(data));

  };

  const handleModalPagination = () => {
    getData();
  };

  const columns = useMemo(
    () => [
      {
        Header: 'Name',
        accessor: 'firstName',
        Cell: (cell: any) => {
          return <div className='label-cell'>{cell?.row?.original?.label}</div>;
        },
      },
      {
        Header: 'Description',
        accessor: 'description',
        Cell: (cell: any) => {
          return <div className='description-cell'>{cell?.row?.original?.scope}</div>;
        },
      },
      {
        Header: 'Status',
        Cell: (cell: any) => {
          const Rowdata = cell?.row?.original;
          return <ToggleSwitch id={cell.row.index} defaultChecked={cell.row.original.status?.toUpperCase() === "ACTIVE" ? true : false}
            onChange={(e: any) => {
              handleToggleSwitch(Rowdata)
            }} />
        }
      },
      {
        Header: 'Action',
        accessor: 'action',
        Cell: (cell: any) => {
          const Rowdata = cell?.row?.original;
          return <div className='actions'>
            <div className="edit" onClick={() => handleEditClick(Rowdata)}>
              <img src={edit} alt="edit" />
            </div>
          </div>
        }
      },
    ], [getClassificationList]);

  return (
    <>
      <div className='table-search'>
        <InputSearch onSearch={handleSearch} value={searchValue} />
      </div>
      <Card className={!getClassificationList ? `loader-card` : ""} >
        <TableWithCardLoader
          data={getClassificationList || []}
          columns={columns}
          loader={getClassificationLoading}
          totalCount={classificationCount}
          customPageSize={Number(pageSize)}
          dynamicPagination={true}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </Card>
      {EditData && (
        <ManageClassificationModal
          showModal={showModal}
          toggle={toggleModal}
          mode='Edit'
          EditData={EditData}
          handleModalPagination={handleModalPagination}
        />
      )}
      {statusData && (
        <ConfirmationModal
          showModal={statusShowModal}
          toggle={toggleStatusModal}
          modalTitle={`Confirmation!`}
          primaryAction={ClassificationUpdateStatus}
          secondaryAction={toggleStatusModal}
          loader={ClassificationStatusLoader}
          primaryBtnName={`${statusData?.status === "INACTIVE" ? 'Activate' : 'Deactivate'}`}
          secoundaryBtnName="Cancel"
          description={`Are you sure, do you want to  ${statusData?.status === "ACTIVE" ? 'deactivate' : 'activate'} this classification  "${statusData?.label} "?`} />
      )}
    </>
  )
}

export default Classifications